// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".info-text{margin-top:8px;padding:8px}", "",{"version":3,"sources":["webpack://src/container/PanelWrapper/UplotPanelWrapper.styles.scss"],"names":[],"mappings":"AAAA,WACC,cAAA,CACA,WAAA","sourcesContent":[".info-text {\n\tmargin-top: 8px;\n\tpadding: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
